/**
 * Tipi ed enum condivisi tra backend e frontend.
 * Rispecchiano gli enum Prisma: se cambia lo schema, cambia anche qui.
 */
export * from "./symbol-spec.js";
export const USER_ROLES = ["ADMIN", "OPERATORE", "CONTABILE", "VIEWER", "CLIENT"];
export const ACCOUNT_ROLES = ["PROP", "BROKER", "NONE"];
export const CYCLE_PHASES = ["PHASE_1", "PHASE_2", "FUNDED"];
export const CYCLE_STATES = ["ACTIVE", "CLOSED_PROFIT", "CLOSED_LOSS", "ABANDONED"];
export const SESSION_STATES = ["ACTIVE", "PAUSED", "COMPLETED", "FAILED"];
export const PAIR_STATES = ["PENDING", "BOTH_OPEN", "ONE_LEG", "CLOSED", "FAILED_OPEN"];
export const CLOSE_REASONS = [
    "PROP_SL_HIT",
    "PROP_TP_HIT",
    "POSITION_DD",
    "DAILY_DD_GUARD",
    "PROP_CLOSED_FIRST",
    "BROKER_CLOSED_FIRST",
    "MANUAL_CLOSE",
    "PROP_BREACH",
    "SESSION_COMPLETE",
    "DESYNC",
];
export const DD_BASES = [
    "STATIC_INITIAL",
    "STATIC_BALANCE",
    "EOD_BALANCE",
    "TRAILING_HIGH_WATER",
    "TRAILING_LOCKED_AT_INITIAL",
];
export const RISK_EVENT_KINDS = [
    "NAKED_LEG_TIMEOUT",
    "DD_THRESHOLD",
    "DAILY_DD_THRESHOLD",
    "SESSION_FAILED",
    "ACCOUNT_DISCONNECTED",
    "PROXY_DOWN",
    "ORDER_REASON_UNEXPECTED",
    "EXECUTION_DESYNC",
    "SYMBOL_SPEC_CHANGED",
    "MIRROR_UNREACHABLE",
];
// ---------------------------------------------------------------------------
// Etichette in italiano per la UI. Tenute qui per non sparpagliare stringhe.
// ---------------------------------------------------------------------------
export const LABELS = {
    accountRole: {
        PROP: "Prop",
        BROKER: "Broker",
        NONE: "Nessun ruolo",
    },
    cyclePhase: {
        PHASE_1: "Fase 1",
        PHASE_2: "Fase 2",
        FUNDED: "Funded",
    },
    cycleState: {
        ACTIVE: "Attivo",
        // Il ciclo chiude alla bruciatura del prop: e' l'esito che si cerca.
        CLOSED_PROFIT: "Chiuso in profitto",
        CLOSED_LOSS: "Chiuso in perdita",
        ABANDONED: "Abbandonato",
    },
    sessionState: {
        ACTIVE: "Attiva",
        PAUSED: "In pausa",
        COMPLETED: "Fase superata",
        // Nel modello Match la bruciatura e' l'esito profittevole: l'etichetta
        // non deve suggerire un errore.
        FAILED: "Conto bruciato",
    },
    pairState: {
        PENDING: "In apertura",
        BOTH_OPEN: "Entrambe aperte",
        ONE_LEG: "Gamba scoperta",
        CLOSED: "Chiusa",
        FAILED_OPEN: "Apertura fallita",
    },
    closeReason: {
        PROP_SL_HIT: "Stop loss sul prop",
        PROP_TP_HIT: "Take profit sul prop",
        POSITION_DD: "Budget DD della posizione esaurito",
        DAILY_DD_GUARD: "Protezione DD giornaliero",
        PROP_CLOSED_FIRST: "Prop chiuso per primo",
        BROKER_CLOSED_FIRST: "Broker chiuso per primo",
        MANUAL_CLOSE: "Chiusura manuale",
        PROP_BREACH: "Conto chiuso dalla prop firm",
        SESSION_COMPLETE: "Fase completata",
        DESYNC: "Chiusura forzata per perdita di sincronia",
    },
    /** Grandezze del ciclo e della sessione, come si chiamano in interfaccia. */
    terms: {
        recoverAmount: "Da recuperare",
        costsRecovered: "Costi recuperati",
        feesPaid: "Fee pagate",
        realRealizedPnl: "P&L realizzato sul reale",
        adjustments: "Rettifiche",
    },
    ddBasis: {
        STATIC_INITIAL: "Statico su saldo iniziale",
        STATIC_BALANCE: "Statico su saldo corrente",
        EOD_BALANCE: "Su saldo di fine giornata",
        TRAILING_HIGH_WATER: "Trailing sul massimo",
        TRAILING_LOCKED_AT_INITIAL: "Trailing con blocco a saldo iniziale",
    },
};
//# sourceMappingURL=index.js.map